import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { BehaviorSubject } from 'rxjs';

export interface FcmMessage {
    notification?: {
        title?: string;
        body?: string;
        image?: string;
    };
    data?: any;
}
@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    currentMessage = new BehaviorSubject<any>(null);
    private currentTokenSubject = new BehaviorSubject<string | null>(null);
    currentToken$ = this.currentTokenSubject.asObservable();
    constructor(private afMessaging: AngularFireMessaging) {
        // this.afMessaging.messages.subscribe(
        //     (message) => {
        //         console.log('Message reçu : ', message);
        //         this.currentMessage.next(message);
        //     },
        //     (err) => console.log('Permission Message refusée : ', err)
        // );
    }

    initMessagingListener() {
        this.afMessaging.messages.subscribe({
            next: (message) => {
                console.log('📩 Message reçu :', message);
                this.currentMessage.next(message);
            },
            error: (err) => console.error('🚫 Erreur réception message :', err)
        });
    }

    requestPermission():Promise<string | null> {
        return new Promise((resolve, reject) => {
        this.afMessaging.requestToken.subscribe({
            next: (token) => {
                if (token) {
                    console.log('Token FCM :', token);
                    this.currentTokenSubject.next(token);
                    resolve(token);
                    // Enregistrer sur le backend
                } else {
                    console.warn('Le token est null, vérifier le service worker et HTTPS');
                    resolve(null);
                }
            },
            error: (err) => {
                reject(err);
                console.error('Permission refusée : ', err)
            }
        })});
    }

    getCurrentToken(): string | null {
        return this.currentTokenSubject.value;
    }
}
